import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconListUl = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z" }) }));
const Memo = memo(SvgIconListUl);
export default Memo;
//# sourceMappingURL=IconListUl.js.map